"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.detectCycle = exports.validateJobGroup = exports.validateAddSchedule = exports.fieldName = exports.fieldDescription = exports.jobGroupField = exports.selectedScheduleField = void 0;
var augur_1 = require("./augur");
var enums_1 = require("../constants/enums");
var lodash_1 = __importDefault(require("lodash"));
var arrayToMap_1 = require("../utils/arrayToMap");
exports.selectedScheduleField = 'selectedSchedule';
exports.jobGroupField = 'jobGroup';
exports.fieldDescription = 'description';
exports.fieldName = 'name';
var validateAddSchedule = function (value) {
    var _a, _b, _c, _d, _e, _f;
    var errors = {};
    // --- Validate name
    var name = value[exports.fieldName];
    if (!name) {
        errors = __assign(__assign({}, errors), (_a = {}, _a[exports.fieldName] = { id: 'todo', defaultMessage: 'Please enter a name.' }, _a));
    }
    // --- Validate description
    var description = value[exports.fieldDescription];
    if (!description) {
        errors = __assign(__assign({}, errors), (_b = {}, _b[exports.fieldDescription] = {
            id: 'todo',
            defaultMessage: 'Please enter a description.',
        }, _b));
    }
    //  Validate the schedule
    if (value[exports.selectedScheduleField] === undefined) {
        Object.assign(errors, (_c = {},
            _c[exports.selectedScheduleField] = {
                general: { id: 'newAugur.schedule.error.general_empty' },
            },
            _c));
    }
    else if (value[exports.selectedScheduleField]) {
        var validation = (0, augur_1.validateSchedule)(__assign(__assign({}, value[exports.selectedScheduleField]), { mode: enums_1.scheduleMode.SCHEDULED }));
        if (!lodash_1.default.isEmpty(validation)) {
            Object.assign(errors, (_d = {}, _d[exports.selectedScheduleField] = validation, _d));
        }
    }
    //  Validate the JobGroup
    // Is there a JobGroup at all?
    if (!value[exports.jobGroupField]) {
        Object.assign(errors, (_e = {},
            _e[exports.jobGroupField] = {
                id: 'orchestration.newAugur.schedule.error.jobs_empty',
            },
            _e));
    }
    else {
        Object.assign(errors, (_f = {},
            _f[exports.jobGroupField] = (0, exports.validateJobGroup)(value[exports.jobGroupField]),
            _f));
    }
    return errors;
};
exports.validateAddSchedule = validateAddSchedule;
/**
 * Validates a JobGroup (that is designed in the 'Add Schedule' wizard)
 *
 * @param jobGroup
 * @returns {null|{id: string}}
 */
var validateJobGroup = function (jobGroup) {
    // Is there at least one job?
    var jobs = jobGroup.jobs;
    if (!jobs || jobs.length === 0) {
        return {
            id: 'orchestration.newAugur.schedule.error.jobs_empty',
            defaultMessage: 'Jobs must not be empty.',
        };
    }
    var jobGroupTopology = jobGroup.jobGroupTopology;
    if (detectCycle(jobGroupTopology)) {
        return {
            id: 'orchestration.newAugur.schedule.error.cycle',
            defaultMessage: 'The Job graph may not contain a cycle.',
        };
    }
    return null;
};
exports.validateJobGroup = validateJobGroup;
/**
 * Find a cycle in the graph by doing DFS and coloring visited vertices. Only traverses based on successors.
 * @param jobGroupTopology
 */
function detectCycle(jobGroupTopology) {
    var jobCodeToTopology = (0, arrayToMap_1.arrayToMap)(jobGroupTopology, 'jobCode');
    var graphRoots = jobGroupTopology.filter(function (jgt) { return jgt.predecessors.length === 0; });
    // jobCodes to color, White = not visited, Grey = on stack, Black = done, closed over on the helper function
    var colorMap = {};
    // Visit vertices recursively, updating the colorMap and returning early with true if a cycle is found
    function detectCycleHelper(vertex) {
        var _a;
        var vertexColor = (_a = colorMap[vertex.jobCode]) !== null && _a !== void 0 ? _a : 'White'; // Unvisited = Not in map = white
        switch (vertexColor) {
            case 'White':
                colorMap[vertex.jobCode] = 'Grey'; // On stack now
                if (vertex.successors.some(function (succ) {
                    return detectCycleHelper(jobCodeToTopology[succ]);
                })) {
                    return true;
                }
                else {
                    colorMap[vertex.jobCode] = 'Black'; // Done with this sub-tree, no need to visit in future
                    return false;
                }
            case 'Grey':
                return true; // Means there is a cycle starting at this vertex, because it was already traversed
            case 'Black':
                return false;
        }
    }
    return (graphRoots.length < 1 || graphRoots.some(function (jgt) { return detectCycleHelper(jgt); }));
}
exports.detectCycle = detectCycle;
//# sourceMappingURL=addSchedule.js.map